/**
 * vendor
 */
import React, { useEffect, useRef, useContext } from 'react';

import EVENT_NAMES  from '@shared/lib/constants/events';
import Emitter      from '@shared/services/main/events';

/**
 * PALTFORM MODULE
 */
import { default as PlatformSessionService } from '@shared/services/session/services/SessionService';
import { PlatformSessionContext } from '@shared/services/session/stores/platform-session-store';

function SessionLoad() {
  const context = useContext(PlatformSessionContext);
  const serviceRef = useRef(null);
  const componentLikeRef = useRef(null);

  const onTokenSuccess = ({sa_token}) => {
    const [, dispatch] = context;
    dispatch({type: 'SET_ACCESS_TOKEN', payload: sa_token});
  };

  useEffect(() => {
    // Create component-like object for service
    const componentLike = {
      setState: () => {},
      state: {},
      context
    };

    componentLikeRef.current = componentLike;
    serviceRef.current = new PlatformSessionService(componentLike);

    serviceRef.current.registerSessionEvents(componentLike, serviceRef.current);
    serviceRef.current.registerSessionTokenEvents(componentLike, serviceRef.current);
    
    /**
     * Start platform session
     */
    Emitter.emit(EVENT_NAMES.PLATFORM.SESSIONS.START_PROCEED, {});

    const tokenSuccessHandler = onTokenSuccess;

    Emitter.register(
      EVENT_NAMES.PLATFORM.SESSIONS.TOKEN_SUCCESS_AFTER + '-session-load',
      tokenSuccessHandler
    );

    return () => {
      if (serviceRef.current) {
        serviceRef.current.removeSessionEvents();
        serviceRef.current.removeSessionTokenEvents();
      }
      Emitter.off(EVENT_NAMES.PLATFORM.SESSIONS.TOKEN_SUCCESS_AFTER + '-session-load');
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (<></>);
}

export default SessionLoad;
